import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getAllInsurances = serviceBase({
  request: options =>
    axiosClient.get('/insurance', {
      params: options,
      paramsSerializer: params =>
        qs.stringify(params, { arrayFormat: 'repeat' })
    }),
  retry: 0
});

export const createNewInsurance = serviceBase({
  request: insurance => axiosClient.post(`/insurance`, insurance),
  retry: 0
});

export const deleteInsurance = serviceBase({
  request: id => axiosClient.delete(`/insurance/${id}`),
  retry: 0
});

export const assignEquipmentsToInsurance = serviceBase({
  request: data => axiosClient.post('/insurance/equipments/assign', data),
  retry: 0
});

export const removeEquipmentFromInsurance = serviceBase({
  request: ({ policyId, equipmentsIds }) =>
    axiosClient.post(`/insurance/equipments/unassign`, {
      policyId,
      equipmentsIds
    }),
  retry: 0
});

export const getInsuranceById = serviceBase({
  request: id => axiosClient.get(`/insurance/detail/${id}`),
  retry: 0
});

export const editInsurance = serviceBase({
  request: ({ policyId, insurance }) =>
    axiosClient.put(`/insurance/${policyId}`, insurance)
});

export const getEquipmentsByPolicyId = serviceBase({
  request: ({ policyId, reqOptions }) => {
    return axiosClient.get(`/insurance/${policyId}/equipments`, {
      params: reqOptions,
      paramsSerializer: params =>
        qs.stringify(params, { arrayFormat: 'repeat' })
    });
  },
  retry: 0
});

export const getAvailableEquipments = serviceBase({
  request: options =>
    axiosClient.get('/insurance/list/not-associated/equipments', {
      params: options,
      paramsSerializer: params =>
        qs.stringify(params, { arrayFormat: 'repeat' })
    }),

  retry: 0
});
